import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xaTdyYnEzMSB7CiAgZGlzcGxheTogaW5saW5lLWZsZXg7CiAgZmxleDogbm9uZTsKICB3aWR0aDogdmFyKC0tXzFpN3JicTMwKTsKICBoZWlnaHQ6IHZhcigtLV8xaTdyYnEzMCk7Cn0';
export var sizeVar = 'var(--_1i7rbq30)';
export var lottieWrapper = '_1i7rbq31';